module.exports = __webpack_public_path__ + "img/BTCD.d4aa87c3.svg";